import React from 'react'
import { motion } from "framer-motion";
import MedtrustHeader from '../../Compoents/MedtrustHeader';
import MedtrustFooter from '../../Compoents/MedtrustFooter';


 const PatientStories = ()  => {

    const testimonials = [
  {
    videoUrl: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
    title: "Multiple Myeloma Treatment in India | Patient Testimonial",
    name: "Glenroy Edwards from Jamaica",
    description:
      "GlenRoy Edwards from Jamaica traveled to India through Lyfboat for the treatment of Multiple Myeloma. Guided by Dr. Suneet and supported by Lyfboat’s dedicated team, he received seamless care—from visa assistance to 24/7 medical support.",
  },
  {
    videoUrl: "https://www.youtube.com/embed/UClF9cDUu2Y",
    title: "Bone Marrow Transplant for Hodgkin's Lymphoma Cancer | Patient Success Story | Lyfboat",
    name: "Zelia Castello from Trinidad and Tobago",
    description:
      "Witness the incredible story of Zelia Castello from Trinidad and Tobago, who underwent a successful bone marrow transplant for Hodgkin’s lymphoma cancer with the support of Lyfboat.",
  },
  {
    videoUrl: "https://www.youtube.com/embed/l5z4O8Gv2CA",
    title: "Multiple Myeloma Treatment in India | Patient Testimonial",
    name: "Glenroy Edwards from Jamaica",
    description:
      "GlenRoy Edwards from Jamaica traveled to India through Lyfboat for the treatment of Multiple Myeloma. Guided by Dr. Suneet and supported by Lyfboat’s dedicated team, he received seamless care—from visa assistance to 24/7 medical support.",
  },
  {
    videoUrl: "https://www.youtube.com/embed/UClF9cDUu2Y",
    title: "Bone Marrow Transplant for Hodgkin's Lymphoma Cancer | Patient Success Story | Lyfboat",
    name: "Zelia Castello from Trinidad and Tobago",
    description:
      "Witness the incredible story of Zelia Castello from Trinidad and Tobago, who underwent a successful bone marrow transplant for Hodgkin’s lymphoma cancer with the support of Lyfboat.",
  },
  {
    videoUrl: "https://www.youtube.com/embed/l5z4O8Gv2CA",
    title: "Multiple Myeloma Treatment in India | Patient Testimonial",
    name: "Glenroy Edwards from Jamaica",
    description:
      "GlenRoy Edwards from Jamaica traveled to India through Lyfboat for the treatment of Multiple Myeloma. Guided by Dr. Suneet and supported by Lyfboat’s dedicated team, he received seamless care—from visa assistance to 24/7 medical support.",
  },
  {
    videoUrl: "https://www.youtube.com/embed/UClF9cDUu2Y",
    title: "Bone Marrow Transplant for Hodgkin's Lymphoma Cancer | Patient Success Story | Lyfboat",
    name: "Zelia Castello from Trinidad and Tobago",
    description:
      "Witness the incredible story of Zelia Castello from Trinidad and Tobago, who underwent a successful bone marrow transplant for Hodgkin’s lymphoma cancer with the support of Lyfboat.",
  },
];


  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-950 to-blue-600 text-white">
      <MedtrustHeader />

      <section className="py-14 px-4 sm:px-6 md:px-10 mt-[120px] bg-white">
        <h2 className="text-5xl md:text-5xl font-bold mb-10 text-center ">
          Patient Testimonials
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8 px-[100px] mx-auto">
          {testimonials.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              viewport={{ once: true, amount: 0.3 }}
              className="bg-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-2xl transition-all duration-300"
            >
              <div className="aspect-video">
                <iframe
                  width="100%"
                  height="100%"
                  src={item.videoUrl}
                  title={item.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="rounded-t-3xl"
                ></iframe>
              </div>

              <div className="p-5">
                <h3 className="font-semibold text-gray-800 mb-2 text-2xl md:text-2xl">
                  {item.name}
                </h3>
                <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                  {item.description}{" "}
                  <a
                    href="#"
                    className="text-blue-600 hover:text-blue-800 font-medium transition-colors"
                  >
                    Read More
                  </a>
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      <MedtrustFooter/>
    </div>
  );
}

export default PatientStories;


